// ===== BANNER COOKIE (GDPR) =====
// Salva la scelta dell'utente e la passa a Shopify (Customer Privacy API), così
// le app e i pixel di Shopify rispettano il consenso.
// Si attiva/disattiva da Personalizza > Impostazioni tema > Cookie e privacy.
(function () {
  const KEY = 'nixsell-cookie-consent';
  const VERSION = 1;          // aumenta se cambi i tipi di cookie: il banner ricompare
  const MAX_AGE_DAYS = 180;   // dopo 6 mesi il banner viene riproposto
  const cfg = window.NixSell || {};
  const listeners = [];

  function read() {
    try {
      const c = JSON.parse(localStorage.getItem(KEY));
      if (!c || c.v !== VERSION) return null;
      if (Date.now() - new Date(c.date).getTime() > MAX_AGE_DAYS * 864e5) return null;
      return c;
    } catch { return null; }
  }

  // Passa il consenso a Shopify
  function sendToShopify(c) {
    const apply = () => {
      if (!window.Shopify || !window.Shopify.customerPrivacy) return;
      window.Shopify.customerPrivacy.setTrackingConsent({
        analytics: c.analytics,
        marketing: c.marketing,
        preferences: true,
        sale_of_data: c.marketing
      }, () => {});
    };
    if (window.Shopify && window.Shopify.customerPrivacy) apply();
    else if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => { if (!err) apply(); });
    }
  }

  function save(analytics, marketing) {
    const c = { v: VERSION, necessary: true, analytics, marketing, date: new Date().toISOString() };
    try { localStorage.setItem(KEY, JSON.stringify(c)); } catch {}
    sendToShopify(c);
    hide();
    listeners.splice(0).forEach((fn) => fn(c));
  }

  // Banner disattivato nelle impostazioni del tema: consideriamo la scelta già fatta
  if (!cfg.cookieBanner) {
    window.NixCookies = { get: read, open() {}, onDecided(fn) { fn(read() || {}); } };
    return;
  }

  const banner = document.createElement('div');
  banner.className = 'cookie-banner';
  banner.setAttribute('role', 'dialog');
  banner.setAttribute('aria-label', 'Preferenze cookie');
  banner.innerHTML = `
    <h4><i class="fa-solid fa-cookie-bite"></i> Questo sito usa i cookie</h4>
    <p>Usiamo cookie tecnici necessari al funzionamento del sito (es. il carrello). Con il tuo consenso potremmo usare
      anche cookie di analisi e marketing. Puoi accettare, rifiutare o scegliere quali attivare, e cambiare idea in
      qualsiasi momento dal link "Preferenze cookie" in fondo alla pagina.
      Leggi la <a href="${cfg.cookiePolicyUrl || '#'}">Cookie policy</a> e la <a href="${cfg.privacyUrl || '#'}">Privacy policy</a>.</p>
    <div class="cookie-prefs">
      <div class="cookie-opt">
        <div><strong>Necessari</strong><span>Carrello, preferenze, sicurezza. Sempre attivi.</span></div>
        <label class="switch"><input type="checkbox" checked disabled><i></i></label>
      </div>
      <div class="cookie-opt">
        <div><strong>Analisi</strong><span>Statistiche anonime sulle visite.</span></div>
        <label class="switch"><input type="checkbox" data-ck-analytics><i></i></label>
      </div>
      <div class="cookie-opt">
        <div><strong>Marketing</strong><span>Annunci personalizzati sui social.</span></div>
        <label class="switch"><input type="checkbox" data-ck-marketing><i></i></label>
      </div>
    </div>
    <div class="cookie-actions">
      <button class="btn btn-ghost" type="button" data-ck="reject">Rifiuta</button>
      <button class="btn btn-ghost" type="button" data-ck="custom">Personalizza</button>
      <button class="btn btn-primary" type="button" data-ck="accept">Accetta tutti</button>
    </div>
  `;
  document.body.appendChild(banner);

  const prefs = banner.querySelector('.cookie-prefs');
  const customBtn = banner.querySelector('[data-ck="custom"]');
  const ckAnalytics = banner.querySelector('[data-ck-analytics]');
  const ckMarketing = banner.querySelector('[data-ck-marketing]');

  function show(withPrefs) {
    const c = read();
    ckAnalytics.checked = !!(c && c.analytics);
    ckMarketing.checked = !!(c && c.marketing);
    prefs.classList.toggle('show', !!withPrefs);
    customBtn.textContent = withPrefs ? 'Salva scelte' : 'Personalizza';
    banner.classList.add('show');
  }
  function hide() { banner.classList.remove('show'); }

  banner.addEventListener('click', (e) => {
    const b = e.target.closest('[data-ck]');
    if (!b) return;
    if (b.dataset.ck === 'accept') save(true, true);
    if (b.dataset.ck === 'reject') save(false, false);
    if (b.dataset.ck === 'custom') {
      if (prefs.classList.contains('show')) save(ckAnalytics.checked, ckMarketing.checked);
      else show(true);
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cookie-settings]')) { e.preventDefault(); show(true); }
  });

  const saved = read();
  if (saved) sendToShopify(saved);
  else show(false);

  window.NixCookies = {
    get: read,
    open: () => show(true),
    // esegue fn quando l'utente ha scelto (subito se ha già scelto)
    onDecided(fn) { const c = read(); if (c) fn(c); else listeners.push(fn); }
  };
})();
